import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AdmissionsPage.css';
import FooterSection from './FooterSection';
import Navbar from './Navbar';

export default function AdmissionsPage() {
  const [openFaq, setOpenFaq] = useState(null);

// Dynamic state holders
  const [importantDates, setImportantDates] = useState([]);
  const [academicYear, setAcademicYear] = useState('2026–27');
  const [academicYearHeading, setAcademicYearHeading] = useState('Important Dates – AY 2026–27');
  const [deadlineDate, setDeadlineDate] = useState('October 25, 2026');
  const [sessionName, setSessionName] = useState('July / August Session');
  const [loadingDates, setLoadingDates] = useState(true);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // const importantDates = [
  //   { label: 'Admission Notification', date: 'July 1, 2025', isImportant: false },
  //   { label: 'Online Application Starts', date: 'July 5, 2025', isImportant: false },
  //   { label: 'Last Date for Submission (Without Fine)', subLabel: 'IMPORTANT DEADLINE', date: 'September 30, 2025', isImportant: true },
  //   { label: 'Last Date (With ₹100 Fine)', date: 'October 15, 2025', isImportant: false },
  //   { label: 'Last Date (With ₹300 Fine)', date: 'October 31, 2025', isImportant: false },
  //   { label: 'Study Material Dispatch', date: 'November 2025', isImportant: false },
  //   { label: 'Contact Classes Begin', date: 'November / December 2025', isImportant: false },
  //   { label: 'Assignment Submission', date: 'February 2026', isImportant: false },
  //   { label: 'Examination', date: 'April / May 2026', isImportant: false }
  // ];

  useEffect(() => {
    const fetchImportantDates = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/admission-dates/important-dates');
        const result = await response.json();

        if (result.success && Array.isArray(result.data) && result.data.length > 0) {
          const rawData = result.data;

          // 1. Format dates list
          const formatted = rawData.map((item) => ({
            label: item.event_title,
            subLabel: item.badge_note || null,
            date: item.event_date,
            isImportant: Boolean(item.is_highlighted)
          }));
          setImportantDates(formatted);

          // 2. Set dynamic academic year & headings
          const firstRecord = rawData[0];
          if (firstRecord.academic_year) {
            // Extracts "2026–27" from "AY 2026–27" or uses as-is
            const yearStr = firstRecord.academic_year.replace(/^AY\s*/i, '');
            setAcademicYear(yearStr);
          }
          if (firstRecord.section_heading) {
            setAcademicYearHeading(firstRecord.section_heading);
          }

          // 3. Find the primary deadline date dynamically
          const deadlineObj = rawData.find(
            (d) =>
              (d.badge_note && d.badge_note.toUpperCase().includes('DEADLINE')) ||
              (d.event_title && d.event_title.toLowerCase().includes('last date'))
          );
          if (deadlineObj && deadlineObj.event_date) {
            setDeadlineDate(deadlineObj.event_date);
          }
        }
      } catch (error) {
        console.error('Error fetching admission dates:', error);
      } finally {
        setLoadingDates(false);
      }
    };

    fetchImportantDates();
  }, []);


  const processSteps = [
    { num: '01', title: 'Choose Your Program', desc: 'Browse our catalog and select a program that matches your educational background and career goals.' },
    { num: '02', title: 'Register Online', desc: 'Fill out the online application form with your personal, academic, and contact details.' },
    { num: '03', title: 'Upload Documents', desc: 'Submit scanned copies of your mark sheets, certificates, photo ID, and passport-sized photograph.' },
    { num: '04', title: 'Pay Fee Online', desc: 'Pay the registration and course fee through our secure payment gateway (Net Banking, UPI, Credit/Debit Card).' },
    { num: '05', title: 'Receive Confirmation', desc: 'Get your admission confirmation, student ID, and study materials dispatched to your address.' },
    { num: '06', title: 'Begin Learning', desc: 'Access your online portal, download study materials, and attend contact classes at your nearest study centre.' }
  ];

  const requiredDocuments = [
    'Recent Passport-Size Photographs (2 copies)',
    'Proof of Date of Birth (10th Mark Sheet / Birth Certificate)',
    'Educational Qualification Certificate (10+2 / UG Mark Sheet)',
    'Community Certificate (SC/ST/OBC - for fee concession)',
    'Photo Identity Proof (Aadhaar Card / Voter ID / Passport)',
    'Transfer Certificate (if applicable)',
    'Experience Certificate (for MBA / working professionals)',
    'Migration Certificate (if from other university)'
  ];

  const eligibilityCriteria = [
    { title: 'UG Programs (BA / BCom / BBA / BCA / BSc)', desc: '10+2 Pass or equivalent from a recognized board. No minimum marks required for most programs.' },
    { title: 'PG Programs (MA / MCom / MBA / MCA / MSc / MSW)', desc: 'Graduation in relevant discipline from a recognized university. MBA accepts any UG degree.' },
    { title: 'PG Diploma Programs', desc: 'Any UG Degree from a recognized university. No specific subject restriction for most PG Diplomas.' },
    { title: 'Certificate Programs', desc: '10th / 10+2 Pass depending on the specific certificate course. Details available in the prospectus.' }
  ];

  const faqs = [
    { q: 'Is the CDOE degree valid for government jobs?', a: 'Yes, all degrees awarded by the Centre for Distance and Online Education (CDOE) are recognized by UGC and DEB, making them completely valid for higher studies and government job applications.' },
    { q: 'Can I apply if I am a working professional?', a: 'Absolute flexibility is designed for working professionals to study at their own pace alongside full-time work commitments.' },
    { q: 'What is the medium of instruction?', a: 'The primary medium of instruction across majority of UG and PG programs is English, with select undergraduate courses available in regional languages.' },
    { q: 'How will I receive study materials?', a: 'Hard copies of comprehensive printed self-learning materials are dispatched via post, and e-learning resources are available instantly on the student portal.' },
    { q: 'Is there any entrance exam for admission?', a: 'Most UG, PG, and Diploma programs offer direct admission based on qualifying examination eligibility without mandatory entrance exams.' },
    { q: 'Can I appear for exams from anywhere?', a: 'Examinations are conducted at designated examination study centers across Tamil Nadu and major cities across India.' }
  ];

  return (
    <>
     <Navbar />
    <div className="admissions-page-wrapper">
      
      {/* 1. Header Banner */}
     {/* 1. Header Banner */}
      <section className="admissions-hero-banner">
        <div className="banner-inner-container">
          
          <div className="banner-left-col">
            {/* Dynamic Breadcrumb */}
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>Admissions {academicYear}</span>
            </nav>

            {/* Dynamic Status Badge */}
            <div className="status-badge-yellow">
              <span className="dot-icon">●</span> Admissions Open – {sessionName} {academicYear.split('–')[0]}
            </div>

            {/* Dynamic Title */}
            <h1>Admissions {academicYear}</h1>

            {/* Dynamic Deadline Text */}
            <p>
              Apply now for UG, PG, Diploma, and Certificate programs. Last date: <strong>{deadlineDate}</strong>.
            </p>
          </div>

          <div className="banner-right-col">
            <Link to="/contact-enquiry" className="btn-apply-online">Apply Online</Link>
            <a href="/prospectus" className="btn-download-prospectus">
              <span className="dl-icon">📥</span> Prospectus
            </a>
          </div>

        </div>
      </section>

      {/* 2. Important Dates Timeline List */}
      {/* <section className="dates-section">
        <div className="admissions-container">
          <div className="centered-header">
            <span className="mini-section-tag">PLAN AHEAD</span>
            <h2>Important Dates – AY 2025–26</h2>
          </div>

          <div className="dates-list-card">
            {importantDates.map((item, idx) => (
              <div key={idx} className={`date-row-item ${item.isImportant ? 'row-important-highlight' : ''}`}>
                <div className="date-row-left">
                  <span className="calendar-icon">📅</span>
                  <div className="label-block">
                    <span className="event-label">{item.label}</span>
                    {item.subLabel && <span className="event-sub-deadline">{item.subLabel}</span>}
                  </div>
                </div>
                <div className="event-date-text">{item.date}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

{/* 2. Important Dates Timeline List */}
      <section className="dates-section">
        <div className="admissions-container">
          <div className="centered-header">
            <span className="mini-section-tag">PLAN AHEAD</span>
            <h2>{academicYearHeading}</h2>
          </div>

          <div className="dates-list-card">
            {loadingDates ? (
              <div style={{ textAlign: 'center', padding: '24px', color: '#64748B' }}>
                Loading admission schedule...
              </div>
            ) : importantDates.length > 0 ? (
              importantDates.map((item, idx) => (
                <div key={idx} className={`date-row-item ${item.isImportant ? 'row-important-highlight' : ''}`}>
                  <div className="date-row-left">
                    <span className="calendar-icon">📅</span>
                    <div className="label-block">
                      <span className="event-label">{item.label}</span>
                      {item.subLabel && <span className="event-sub-deadline">{item.subLabel}</span>}
                    </div>
                  </div>
                  <div className="event-date-text">{item.date}</div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: '24px', color: '#64748B' }}>
                No active dates announced at this time.
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 3. Step By Step Admission Process Grid */}
      <section className="process-section">
        <div className="admissions-container">
          <div className="centered-header">
            <span className="mini-section-tag">STEP BY STEP</span>
            <h2>Admission Process</h2>
          </div>

          <div className="process-steps-grid">
            {processSteps.map((step, idx) => (
              <div key={idx} className="step-card">
                <span className="step-number">{step.num}</span>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>

          <div className="action-center-wrapper">
            <button className="btn-start-application">
              Start Application <span className="arrow-icon">➔</span>
            </button>
          </div>
        </div>
      </section>

      {/* 4. Documents & Eligibility Dual Column Section */}
      <section className="docs-eligibility-section">
        <div className="admissions-container grid-dual-col">
          
          {/* Left Sub-Column: Required Documents */}
          <div className="docs-sub-col">
            <span className="mini-section-tag">BE PREPARED</span>
            <h2>Required Documents</h2>
            
            <div className="docs-list">
              {requiredDocuments.map((doc, idx) => (
                <div key={idx} className="doc-pill-item">
                  <span className="check-icon">✓</span>
                  <span>{doc}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Sub-Column: Eligibility Criteria */}
          <div className="eligibility-sub-col">
            <h2>Eligibility Criteria</h2>
            
            <div className="eligibility-cards-list">
              {eligibilityCriteria.map((item, idx) => (
                <div key={idx} className="eligibility-card">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="eligibility-cta-row">
              <button className="btn-view-fee">📄 View Fee Structure</button>
              <button className="btn-app-form">📥 Application Form</button>
            </div>
          </div>

        </div>
      </section>

      {/* 5. Frequently Asked Questions (FAQ Accordion) */}
      <section className="faq-section">
        <div className="admissions-container narrow-container">
          <div className="centered-header">
            <h2>Frequently Asked Questions</h2>
          </div>

          <div className="faq-accordion-list">
            {faqs.map((faq, idx) => (
              <div key={idx} className={`faq-item-card ${openFaq === idx ? 'faq-active' : ''}`}>
                <div className="faq-question-head" onClick={() => toggleFaq(idx)}>
                  <div className="faq-q-left">
                    <span className="help-icon">❓</span>
                    <span className="question-text">{faq.q}</span>
                  </div>
                  <span className="chevron-arrow">{openFaq === idx ? '▲' : '▼'}</span>
                </div>

                {openFaq === idx && (
                  <div className="faq-answer-body">
                    <p>{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
        <FooterSection/>
        </>
  );
}